module.exports = __webpack_public_path__ + "static/media/amsh-web.b64e68cf.svg";